export default function SectionBadge({ children }) {
  if (!children) return null

  return (
    <div className="text-bold ml-2 mt-0.5 flex h-5 w-5 items-center justify-center rounded-full bg-red-600 p-2 text-xs text-white">
      {children}
    </div>
  )
}
